import {
    KboExplorationNode,
    KboFlowRunOutput,
} from "../KboFlowDebug/KboFlowRunDebug";

export type StepDebugNodeOption = {
    node: KboExplorationNode;
    emailFindingTitle?: string;
};

/**
 * Puts the terminal node behind each emailed finding first, in report/finding order. The rest
 * retain exploration order so the picker is deterministic without reconstructing the tree.
 */
export function getStepDebugNodeOptions(
    output: KboFlowRunOutput,
): StepDebugNodeOption[] {
    const emailedFindingByNodeId = new Map<
        string,
        { title?: string; rank: number }
    >();
    let rank = 0;
    for (const report of output.reports ?? []) {
        for (const finding of report.data?.findings ?? []) {
            const nodeId = [...(finding.explorationPath ?? [])]
                .reverse()
                .find((step) => step.explorationNodeId)?.explorationNodeId;
            if (nodeId && !emailedFindingByNodeId.has(nodeId)) {
                emailedFindingByNodeId.set(nodeId, {
                    title: finding.title?.trim(),
                    rank,
                });
            }
            rank += 1;
        }
    }

    const options = (output.exploration?.nodes ?? []).map((node, index) => {
        const emailedFinding = node.nodeId
            ? emailedFindingByNodeId.get(node.nodeId)
            : undefined;
        return {
            node,
            index,
            emailFindingTitle: emailedFinding?.title,
            emailFindingRank: emailedFinding?.rank,
        };
    });
    options.sort(
        (left, right) =>
            (left.emailFindingRank ?? Number.MAX_SAFE_INTEGER) -
                (right.emailFindingRank ?? Number.MAX_SAFE_INTEGER) ||
            left.index - right.index,
    );
    return options.map(({ node, emailFindingTitle }) => ({
        node,
        emailFindingTitle,
    }));
}
